import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions } from "@angular/material/dialog";
import { DeialogIaNa } from "src/app/craidd/modelau/ui/deialog-ia-na";
import { FaIconComponent } from "@fortawesome/angular-fontawesome";
import { CdkScrollable } from "@angular/cdk/scrolling";
import { MatButton } from "@angular/material/button";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
    selector: "app-deialog-ia-na",
    templateUrl: "./deialog-ia-na.component.html",
    styleUrls: ["./deialog-ia-na.component.scss"],
    imports: [
        MatDialogTitle,
        FaIconComponent,
        CdkScrollable,
        MatDialogContent,
        MatDialogActions,
        MatButton,
        TranslatePipe,
    ],
})
export class DeialogIaNaComponent {
  constructor(
    public dialogRef: MatDialogRef<DeialogIaNaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DeialogIaNa,
  ) {}

  clicNa() {
    this.dialogRef.close(false);
  }

  clicIa() {
    this.dialogRef.close(true);
  }
}
